import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonashikbusonrentpackage() {



  const cardData =
  {
    keyword: 'Pune to Nashik Bus on Rent Packages ',
    heading: 'Sanavi Travels: Pune to Nashik Bus on Rent Packages',
    headingDescription: 'Sanavi Travels offers reliable Pune to Nashik Bus on Rent Packages, providing safe, comfortable, and well-organized transportation solutions for families, corporate groups, pilgrims, tourists, and event travel planning a smooth journey from Pune to Nashik. Our fleet of AC and Non-AC buses ranging from 20, 25, 30, 32, 35, 40, 45 to 50 seaters, along with tempo travellers on request, is well-maintained and equipped with push-back seating, ample legroom, and spacious luggage capacity to ensure a relaxed short and long-distance travel experience. With experienced route drivers, flexible one-way and round-trip rental options, transparent pricing, and dependable service, Sanavi Travels guarantees punctual pickups and hassle-free travel. We offer convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular Nashik destinations such as Trimbakeshwar Temple, Sula Vineyards, Panchavati, Ramkund, Anjaneri Hills, and nearby religious and tourist attractions. Choose Sanavi Travels for dependable Pune to Nashik bus rental packages, ensuring comfort, safety, and a seamless group travel experience.',

    top: 'Top Places to Visit in Nashik with Sanavi Travels',


"topPlaces": [
  {
    "title": "Trimbakeshwar Temple",
    "description": "Trimbakeshwar Temple is one of the twelve Jyotirlingas of Lord Shiva and the most sacred site in Nashik. Located near the origin of the Godavari River, the temple features unique architecture where the Jyotirlinga represents Brahma, Vishnu, and Mahesh. It is an important pilgrimage center, especially during Kumbh Mela. Trimbakeshwar holds immense spiritual significance and attracts devotees from across India."
  },
  {
    "title": "Sula Vineyards",
    "description": "Sula Vineyards is India’s most famous wine destination, offering a perfect blend of luxury, leisure, and scenic beauty. Visitors can explore vineyards, enjoy wine-tasting sessions, and relax amidst rolling hills. The annual SulaFest attracts music and wine lovers from around the country. Sula Vineyards represents Nashik’s modern lifestyle and global appeal."
  },
  {
    "title": "Panchavati",
    "description": "Panchavati is a sacred area associated with the Ramayana, believed to be the place where Lord Rama spent time during his exile. Key attractions include Sita Gufa, Kapaleshwar Temple, and Ramkund. The Godavari River flows gently through the area, adding to its spiritual aura. Panchavati is the religious heart of Nashik."
  },
  {
    "title": "Ramkund",
    "description": "Ramkund is a holy bathing ghat on the banks of the Godavari River, where devotees perform rituals and last rites. It is believed that a dip here washes away sins. During Kumbh Mela, Ramkund becomes the focal point for millions of pilgrims. The ghat holds deep religious and cultural importance in Nashik."
  },
  {
    "title": "Pandavleni Caves",
    "description": "Pandavleni Caves, also known as Nashik Caves, are ancient rock-cut Buddhist caves dating back to the 1st century BCE. The caves feature inscriptions, meditation halls, and water tanks. Located on a hill, they offer panoramic views of Nashik city. Pandavleni reflects Nashik’s rich historical and spiritual past."
  },
  {
    "title": "Anjaneri Hills",
    "description": "Anjaneri Hills is believed to be the birthplace of Lord Hanuman and is a popular trekking destination near Nashik. Surrounded by lush greenery, waterfalls, and ancient caves, it offers breathtaking natural beauty. The hill is especially attractive during monsoon. Anjaneri Hills is perfect for devotees, trekkers, and nature lovers."
  },
  {
    "title": "Gangapur Dam",
    "description": "Gangapur Dam is a peaceful picnic and leisure spot near Nashik, offering scenic views of calm waters and surrounding hills. The area is popular for boating, photography, and sunset views. It also supports nearby vineyards and agriculture. Gangapur Dam provides a refreshing escape into nature."
  },
  {
    "title": "Someshwar Waterfall",
    "description": "Someshwar Waterfall is a seasonal waterfall located near Someshwar Temple. It becomes lively during monsoon when water cascades down rocky terrain. Locals and tourists visit for short trips and photography. The waterfall adds to Nashik’s natural charm."
  },
  {
    "title": "Kalaram Temple",
    "description": "Kalaram Temple is a significant Hindu temple dedicated to Lord Rama, built with black stone. It played an important role in India’s social reform movement led by Dr. B.R. Ambedkar. The temple showcases beautiful architecture and spiritual importance. Kalaram Temple is a key cultural landmark of Nashik."
  },
  {
    "title": "Coin Museum",
    "description": "The Coin Museum in Nashik is the only museum in India dedicated entirely to the study of currency. It displays ancient coins, paper money, and the history of Indian currency systems. The museum offers educational insights for students and history enthusiasts. It adds a unique cultural dimension to Nashik’s tourism."
  }
]
,





"services": [
  {
    "name": "Pune to Nashik Bus on Rent Packages",
    "description": "Pune to Nashik Bus on Rent Packages offer comfortable and well-planned bus travel options for groups visiting Nashik from Pune. Ideal for family trips, religious tours, and leisure travel, these packages include spacious buses, professional drivers, and smooth highway journeys. The service ensures safety, punctuality, and a relaxed travel experience for all passengers."
  },
  {
    "name": "Nashik Bus Hire from Pune",
    "description": "Nashik Bus Hire from Pune provides reliable bus rental services for short or long trips. Suitable for families, tourists, and corporate groups, the service focuses on comfortable seating, experienced chauffeurs, and timely travel, making journeys between Pune and Nashik convenient and stress-free."
  },
  {
    "name": "AC Bus Pune to Nashik",
    "description": "AC Bus Pune to Nashik offers air-conditioned buses for a cool and comfortable journey, especially during long-distance or summer travel. With spacious interiors and smooth suspension, passengers enjoy a relaxed ride while traveling safely on highways."
  },
  {
    "name": "Luxury Nashik Tour Bus",
    "description": "Luxury Nashik Tour Bus provides premium buses with elegant interiors and enhanced comfort for a superior travel experience. Ideal for VIP travel, corporate outings, or special family trips, this service combines style, safety, and convenience."
  },
  {
    "name": "Family Nashik Bus Trip",
    "description": "Family Nashik Bus Trip is designed for families traveling together from Pune to Nashik. With comfortable seating, safe driving practices, and ample luggage space, this service ensures an enjoyable and stress-free journey for all age groups."
  },
  {
    "name": "Group Travel Nashik Bus",
    "description": "Group Travel Nashik Bus caters to large groups such as friends, tour groups, or organizations. Spacious buses and coordinated travel arrangements ensure everyone travels together comfortably, making group trips to Nashik smooth and organized."
  },
  {
    "name": "Affordable Nashik Bus Package",
    "description": "Affordable Nashik Bus Package offers budget-friendly travel solutions without compromising on comfort or safety. Ideal for cost-conscious travelers, this service provides well-maintained buses, professional drivers, and transparent pricing."
  },
  {
    "name": "Chauffeur Driven Nashik Bus",
    "description": "Chauffeur Driven Nashik Bus provides experienced and professional drivers who ensure safe and punctual travel. Passengers can relax and enjoy the journey while chauffeurs handle routes, traffic, and driving responsibilities."
  },
  {
    "name": "Best Nashik Bus Service Pune",
    "description": "Best Nashik Bus Service Pune is known for reliable buses, comfortable travel, and professional service. Suitable for families, tourists, and corporate groups, this service focuses on punctuality, safety, and overall passenger satisfaction."
  },
  {
    "name": "Pune Nashik Travel Bus",
    "description": "Pune Nashik Travel Bus offers dependable transportation between Pune and Nashik for sightseeing, religious visits, and leisure trips. Spacious seating and skilled drivers ensure a smooth and pleasant journey."
  },
  {
    "name": "Tourist Bus Hire Nashik",
    "description": "Tourist Bus Hire Nashik provides buses for sightseeing and tourism within Nashik. Ideal for visiting temples, vineyards, and popular attractions, this service ensures organized travel with comfort and convenience."
  },
  {
    "name": "Wine Tour Bus Nashik",
    "description": "Wine Tour Bus Nashik is specially designed for vineyard and wine tourism trips. Comfortable buses and experienced drivers make it easy for groups to explore Nashik’s famous wineries while enjoying a relaxed and safe journey."
  },
  {
    "name": "Weekend Trip Bus Nashik",
    "description": "Weekend Trip Bus Nashik offers convenient travel solutions for short weekend getaways. Ideal for families, friends, and corporate groups, this service ensures timely travel, comfort, and a refreshing trip experience."
  },
  {
    "name": "Holiday Bus Package Nashik",
    "description": "Holiday Bus Package Nashik provides organized travel options for leisure and holiday trips. Designed for stress-free travel, this service focuses on comfortable buses, sightseeing convenience, and enjoyable journeys."
  },
  {
    "name": "Nashik Darshan Bus Service",
    "description": "Nashik Darshan Bus Service offers dedicated bus travel for religious and temple visits in Nashik. Suitable for devotees and group pilgrimages, this service ensures safe, comfortable, and well-coordinated darshan tours."
  }
],
"tableData": [
  ["Pune to Nashik Bus on Rent Packages", "Nashik Bus Hire from Pune"],
  ["AC Bus Pune to Nashik", "Luxury Nashik Tour Bus"],
  ["Family Nashik Bus Trip", "Group Travel Nashik Bus"],
  ["Affordable Nashik Bus Package", "Chauffeur Driven Nashik Bus"],
  ["Best Nashik Bus Service Pune", "Pune Nashik Travel Bus"],
  ["Tourist Bus Hire Nashik", "Wine Tour Bus Nashik"],
  ["Weekend Trip Bus Nashik", "Holiday Bus Package Nashik"],
  ["Nashik Darshan Bus Service", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Nashik Bus on Rent Packages with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rental packages from Pune to Nashik, ideal for group tours, family trips, corporate travel, and long-distance journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and well-serviced buses ensuring a smooth and enjoyable journey from Pune to Nashik."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune–Nashik Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with Pune–Nashik highways, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for Pune to Nashik bus on rent packages, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, itinerary planning, and travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized bus rental packages tailored to your Pune to Nashik travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure passenger safety and hygiene."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Nashik bus on rent packages."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels offer bus on rent packages from Pune to Nashik?',
    answer: 'Yes, Sanavi Travels provides comfortable and well-maintained buses for group travel from Pune to Nashik.'
  },
  {
    question: 'How can I book a Pune to Nashik bus rental package with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What type of buses are available for Pune to Nashik travel?',
    answer: 'We provide air-conditioned and non-AC buses in various seating capacities suitable for group travel.'
  },
  {
    question: 'Are drivers included in the bus on rent package?',
    answer: 'Yes, all rental packages include experienced and professional drivers familiar with Pune–Nashik routes.'
  },
  {
    question: 'Is the Pune to Nashik bus rental service available 24x7?',
    answer: 'Yes, our service is available round the clock for bookings and travel.'
  },
  {
    question: 'Are the buses sanitized before the trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the Pune to Nashik bus rental package?',
    answer: 'Absolutely. Sanavi Travels offers customized rental packages according to your travel needs.'
  },
  {
    question: 'What payment options are available for bus rental bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Nashik trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Manoj Kulkarni',
    feedback: 'Booked a Pune to Nashik bus rental package with Sanavi Travels. Very comfortable bus, professional driver, and timely service. Highly recommend!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Ritu Patil',
    feedback: 'Excellent experience! Clean bus, smooth journey, and great coordination. Our group trip to Nashik was memorable.',
    rating: 5
  }
];
































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];





const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nashik Bus on Rent Packages - Sanavi Travels",
  "description": "Pune to Nashik bus rental packages by Sanavi Travels for family trips, group travel, wine tours, weekend trips, and holiday tours. Choose AC and luxury buses for safe, comfortable, and affordable travel from Pune to Nashik.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1680"
  }
};










  return (
    <div>
<Helmet>
  <title>
    Pune to Nashik Bus on Rent Packages Starting from ₹50 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Pune to Nashik bus rental packages with Sanavi Travels. AC and luxury buses for family trips, group travel, wine tours, weekend trips, and holiday tours at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/37.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetonashikbusonrentpackage;